import { Button, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import RecipientInfoComponent from "./components/RecipientInfoComponent";
import { useUserInfoQuery } from "../../api/userApiSlice";
import StepperDUC from "./StepperDUC";
import { useNavigate } from "react-router-dom";

interface FormValues {
        firstName: string
        lastName: string
        degree: string
        institution: string
        city: string
        state: string
        country: string
        phone: string
        email: string
}

const Recipients = (props: any) => {
    const navigate = useNavigate();

    const { data: userData } = useUserInfoQuery({});
    const [firstRender, setFirstRender] = useState(false);
    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<FormValues>({
        defaultValues: {
            firstName: userData.firstName || "",
            lastName: userData.lastName || "",
            degree: props.DUCInfo?.degree || props.prevData?.data?.degree || "",
            institution: props.DUCInfo?.institution || props.prevData?.data?.institution ||  "",
            city:  props.DUCInfo?.city || props.prevData?.data?.city || "",
            state:  props.DUCInfo?.state || props.prevData?.data?.state || "",
            country: props.DUCInfo?.country || props.prevData?.data?.country || "",
            phone:  props.DUCInfo?.phone || props.prevData?.data?.phone ||"",
            email: userData.email || ""
        }
    });

    //This useEffect is used for the case of editing a previous entry
    //we need to add the setvalue because prevdata is undefined
    //on the first render usually so the default value does not always work
    //we only want to set if it's the first render because if the user is navigating
    //back to this step we do not want to overwrite the values they inputted
    useEffect(() => {
        if(!props.prevData?.data){
            setFirstRender(true)
        }
        else if(props.prevData?.data && firstRender){
            setValue("degree", props.prevData?.data?.degree || "")
            setValue("institution", props.prevData?.data?.institution || "")
            setValue("city", props.prevData?.data?.city || "")
            setValue("state", props.prevData?.data?.state || "")
            setValue("country", props.prevData?.data?.country || "")
            setValue("phone", props.prevData?.data?.phone || "")

        }
    }, [props.prevData]);

    const handleClick = (newData: FormValues) => {
        props.setDUCInfo({ ...props.DUCInfo, ...newData });

        props.setCurStep(props.curStep + 1);
    }

    const handleClickBack = () => {
        navigate("/duc")
    }

    return (
        <Stack flexDirection="column" gap={3}>
            <Stack flexDirection="column" gap={4}>
                <StepperDUC
                    activeStep={props.curStep}
                    stepLabels={props.stepLabels} />
            </Stack>

            <Typography
                variant="h2"
                fontSize="20px"
                fontWeight="600"
            >
                    Lead Recipient
            </Typography>
            <RecipientInfoComponent
                control={control}
                errors={errors}
            /> 

            <Stack
                flexDirection="row"
                justifyContent="space-between">
                    
                <Button
                    id="duc-flow-back-button"
                    variant="tertiary"
                    onClick={handleClickBack}
                    sx={{ alignSelf: "center" }}
                >
                        Back
                </Button>

                <Button
                    id="duc-flow-continue-button"
                    variant="primary"
                    onClick={handleSubmit(handleClick)}
                    sx={{ alignSelf: "center" }}
                >
                        Continue
                </Button>
            </Stack>
        </Stack>
    )
}

export default Recipients;



